import type { AiComponentDto } from '@terra/shared-contracts-ai-applications';
import { isMcpUserFacingAssetType } from '@terra/shared-contracts-ai-applications';
import {
  countAgentComponents,
  isSupportingComponent,
} from '@terra/ui-ai-applications';

const isListedComponent = (component: AiComponentDto): boolean =>
  component.verificationStatus !== 'SUPPRESSED';

export function resolveAiApplicationComponentKpis({
  components,
  aiKind,
}: {
  components: AiComponentDto[];
  aiKind: string;
}): { agents: number; components: number } {
  const agents = countAgentComponents(components);
  const listedComponents = components.filter(isListedComponent);
  const supportingComponents =
    aiKind === 'MCP_SERVER'
      ? listedComponents.filter((component) =>
          isMcpUserFacingAssetType(component.type),
        ).length
      : listedComponents.filter(isSupportingComponent).length;

  return { agents, components: supportingComponents };
}
